// import toast from "react-hot-toast";
import instance from "../../network/index"; // Import your axios instance
import { handleToast } from "@/network/helper";

// Centralized error handler
const handleError = (err, defaultMessage) => {
  console.error(defaultMessage, err);
  const message = err.response?.data?.message || err.message || defaultMessage;
  handleToast({ err: { response: { data: { message } } } });
};

const createTeam = async (data) => {
  try {
    const response = await instance.post("/api/v1/teams", data);
    if (response?.status === 200 || response?.status === 201) {
      handleToast({
        res: { message: "Teams Added" },
      });
    }
    return response?.data;
  } catch (error) {
    // Log and rethrow error for further handling
    console.error("Error creating brand:", error);
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data,
      );
    }
    handleError(error, "Something went Wrong While Creating Brand");
  }
};

const inviteUser = async (data) => {
  try {
    const response = await instance.post("/api/v1/users/invite", data);
    if (response?.status === 200 || response?.status === 201) {
      handleToast({
        res: { message: "Member Invited" },
      });
      return response?.data;
    }
  } catch (error) {
    // Log and rethrow error for further handling
    console.error("Error Inviting user:", error);
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data,
      );
    }
    // handleError(error, "Something went Wrong While Inviting user")
  }
};

const getInvitedUser = async (token) => {
  try {
    const response = await instance.get(`/api/v1/users/invite/${token}`);
    if (response?.status === 200 || response?.status === 201) {
      handleToast({
        res: { message: "Link Verified" },
      });
      return response?.data;
    }
  } catch (error) {
    // Log and rethrow error for further handling
    console.error("Error while verifying user:", error);
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data,
      );
    }
    handleError(error, "Something went Wrong While Verifying user");
    return error;
  }
};

// Function to create a brand
const createBrand = async (data) => {
  try {
    const response = await instance.post("/api/v1/brands", data);
    if (response?.status === 200 || response?.status === 201) {
      handleToast({
        res: { message: "Brand Created Successfully!" },
      });
    }
    return response?.data;
  } catch (error) {
    // Log and rethrow error for further handling
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data,
      );
    }
    handleError(error, "Something went Wrong While Creating Brand");
  }
};
// Function to update a brand
const updateBrand = async (id, data) => {
  try {
    const response = await instance.patch(`/api/v1/brands/${id}`, data);
    if (response?.status === 200 || response?.status === 201) {
      handleToast({
        res: { message: "Brand Updated Successfully!" },
      });
    }
    return response?.data;
  } catch (error) {
    // Log and rethrow error for further handling
    console.error("Error updating brand:", error);
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data,
      );
    }
    handleError(error, "Something went Wrong While updating Brand");
  }
};

// Function to update a brand
const updateOrganizationName = async (data) => {
  try {
    const response = await instance.patch(`/api/v1/organization/`, data);
    if (response?.status === 200 || response?.status === 201) {
      handleToast({
        res: { message: "Organization Name updated successfully!" },
      });
    }
    return response?.data;
  } catch (error) {
    // Log and rethrow error for further handling
    console.error("Error updating organization name:", error);
    if (error.response) {
      console.error(
        `Error status: ${error.response.status}`,
        error.response.data,
      );
    }
    handleError(error, "Something went Wrong While updating organization name");
  }
};

const fetchOrganization = async () => {
  try {
    const res = await instance.get("/api/v1/organization");
    const organizationData = res?.data?.data;
    return organizationData;
  } catch (err) {
    console.log(err);
    handleError(err, "Something went Wrong While fetching organization");
  }
};

const updateUserLicenseStatus = async (data) => {
  try {
    const response = await instance.patch("/api/v1/organization/license", data);

    return response?.data;
  } catch (err) {
    return err;
  }
};

const fetchPaymentDetailsByCustomerID = async (customer_id) => {
  try {
    const response = await fetch(`/api/list-payments/${customer_id}`, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch payment details. Status: ${response.status}`,
      );
    }

    const data = await response.json();

    const filteredData = Array.isArray(data)
      ? data.filter((payment) => payment.total_amount > 0)
      : [];

    return filteredData;
  } catch (error) {
    console.error("Fetch error:", error);
    return [];
  }
};

const getLicenseInfo = async () => {
  try {
    const response = await instance.get("/api/v1/organization/license");

    if (response?.status === 200) {
      return response?.data?.data;
    }
  } catch (err) {
    console.log(err);
    handleError(err, "Something went Wrong While fetching members");
  }
};

const getSubDetailsApi = async () => {
  try {
    const res = await instance.get("/api/v1/subscription?include=items");
    const subDetails = res?.data?.data; // Accessing the subscription object directly
    return subDetails;
  } catch (err) {
    console.error("Error:", err?.message);
    return {};
  }
};

const fetchUserApi = async () => {
  try {
    const res = await instance.get("/api/user");

    if (res?.status === 200 && res?.data?.data) {
      const userData = res.data.data;
      return userData; // ✅ Ensures user data is always returned on success
    }
  } catch (err) {
    console.log(err, "error");
    return {};
  }
  return null; // ✅ Always returns a value, even in case of an error
};

const generateToken = async () => {
  const response = await instance.post("/api/user/token");
  return response.data;
};

const createCustomerInDodo = async (customerData, method) => {
  const response = await fetch("/api/customer", {
    method: method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ obj: customerData }),
  });
  return await response.json();
};

export {
  createTeam,
  inviteUser,
  getInvitedUser,
  createBrand,
  updateBrand,
  fetchPaymentDetailsByCustomerID,
  updateOrganizationName,
  fetchOrganization,
  updateUserLicenseStatus,
  getLicenseInfo,
  getSubDetailsApi,
  fetchUserApi,
  generateToken,
  createCustomerInDodo
};
